"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const delivery_model_1 = require("./delivery.model");
const language_model_1 = require("./language.model");
const product_model_1 = require("./product.model");
const lexbot_model_1 = require("./lexbot.model");
const feature_model_1 = require("./feature.model");
const state_model_1 = require("./state.model");
const region_model_1 = require("./region.model");
const account_intent_model_1 = require("../schema/account-intent.model");
const account_slot_model_1 = require("../schema/account-slot.model");
const locale_model_1 = require("./locale.model");
const account_services_model_1 = require("../schema/account-services.model");
const phonereg = /^[0-9]{3,14}$/;
const colorHexCode = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
exports.AccountSchema = yup_lib_1.default.object().shape({
    clientName: yup_lib_1.default
        .string()
        .required()
        .max(50, 'Must be maximum of 50 character')
        .label('Client Name'),
    state: state_model_1.accountStateSchema,
    city: yup_lib_1.default.string().required().label('City'),
    region: region_model_1.accountRegionSchema,
    serviceName: yup_lib_1.default
        .string()
        .required()
        .max(30, 'Must be maximum of 30 character')
        .label('Service Name'),
    number: yup_lib_1.default
        .string()
        .matches(phonereg, 'Please enter a numeric value between 3 and 14 digits long')
        .required()
        .label('Phone Number'),
    usedLexBot: lexbot_model_1.accountLexBotSchema,
    products: yup_lib_1.default.array().of(product_model_1.accountProductSchema).min(1).required().label('Products'),
    features: yup_lib_1.default.array().of(feature_model_1.accountFeatureSchema).min(1).notRequired().label('Features'),
    clientAdmins: yup_lib_1.default.string().notRequired().label('Client Admins'),
    alertCategories: yup_lib_1.default.string().notRequired().label('Alert Categories'),
    greetingCopy: yup_lib_1.default.string().required().label('Greeting Copy'),
    webChatDesignElements: yup_lib_1.default.string().notRequired(),
    languages: yup_lib_1.default.array().of(language_model_1.accountLanguageSchema).notRequired().label('Language'),
    intents: yup_lib_1.default.array().of(account_intent_model_1.AccountIntentSchema).max(1000).notRequired(),
    services: yup_lib_1.default.array().of(account_services_model_1.AccountServiceModelSchema).notRequired(),
    deliveries: yup_lib_1.default.array().of(delivery_model_1.deliverySchema).notRequired(),
    lexBotInfo: yup_lib_1.default.object().notRequired().label('Lex bot Info'),
    slotTypes: yup_lib_1.default.array().of(account_slot_model_1.AccountSlotSchema).max(250).notRequired(),
    botDescription: yup_lib_1.default
        .string()
        .required()
        .max(100, 'Must be maximum of 100 character')
        .label('Bot Description'),
    isChildDirected: yup_lib_1.default.boolean().required().label('Is Child Directed'),
    idleSessionTTLInSeconds: yup_lib_1.default.number().required().label('Idle Session TTL'),
    nluConfidenceThreshold: yup_lib_1.default.number().min(0).max(1).required().label('NLU COnfidence Threshold'),
    locales: yup_lib_1.default.array().of(locale_model_1.LocaleCodeTypeSchema).min(1).required().label('Locales'),
    scoutAgentId: yup_lib_1.default.string().notRequired().label('Scout Agent Id'),
    scoutTurboAppId: yup_lib_1.default
        .string()
        .notRequired()
        .max(50, 'Must be maximum of 50 character')
        .label('Scout Turbo Id'),
    logoImgUrl: yup_lib_1.default.string().when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().required().label('Logo Image')
    }),
    chatOpenningImgUrl: yup_lib_1.default.string().when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().required().label('Chat Open Image')
    }),
    chatCloseImgUrl: yup_lib_1.default.string().when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().required().label('Chat Close Image')
    }),
    botProfileImgUrl: yup_lib_1.default.string().when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().required().label('Bot Profile Image')
    }),
    chatWidgetTitle: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().required().max(30, 'Must be maximum of 30 character')
    })
        .label('Chat Widget Title'),
    chatWidgetSubTitle: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().required().max(30, 'Must be maximum of 30 character')
    })
        .label('Chat Widget Subtitle'),
    headerBackgroundColor: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().matches(colorHexCode, 'Please enter color Hex Code').required()
    })
        .label('Header Background Colour'),
    headerTextColor: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().matches(colorHexCode, 'Please enter color Hex Code').required()
    })
        .label('Header Text Colour'),
    messageBackgroundColor: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().matches(colorHexCode, 'Please enter color Hex Code').required()
    })
        .label('Message Background Colour'),
    messageTextColor: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().matches(colorHexCode, 'Please enter color Hex Code').required()
    })
        .label('Message Text Colour'),
    enableMessageButton: yup_lib_1.default.boolean().notRequired(),
    multilingual: yup_lib_1.default.boolean().notRequired(),
    isAllowAnonymous: yup_lib_1.default.boolean().notRequired()
});
